import { useQuery } from '@tanstack/react-query';
import {
  getOnboardingAnalytics,
  getOnboardingUserStatus,
  type UserStatusFilters,
} from '../../services/onboarding.service';

export const onboardingKeys = {
  all: ['onboarding'] as const,
  analytics: (schoolId?: number) =>
    [...onboardingKeys.all, 'analytics', schoolId] as const,
  users: (filters: UserStatusFilters) =>
    [...onboardingKeys.all, 'users', filters] as const,
};

export function useOnboardingAnalytics(schoolId?: number) {
  return useQuery({
    queryKey: onboardingKeys.analytics(schoolId),
    queryFn: () => getOnboardingAnalytics(schoolId),
    staleTime: 60_000,
  });
}

export function useOnboardingUsers(filters: UserStatusFilters) {
  return useQuery({
    queryKey: onboardingKeys.users(filters),
    queryFn: () => getOnboardingUserStatus(filters),
    staleTime: 30_000,
    placeholderData: (previousData) => previousData,
  });
}
